<div class="public-page">

  <div class="content-header">

    <div class="section-title">About Curriculum Links</div>

  </div>

  <p>
    Curriculum Links is a custom-built tool developed by the <a href="https://taylorinstitute.ucalgary.ca"
      target="_blank">Taylor
      Institute for Teaching and Learning</a>, University of Calgary.
    Useful for both curriculum review and the development of new programs, it can gather information such as learning
    outcomes, teaching and learning
    activities, and student assessments. The tool allows for customizable program reports from aggregate data.
  </p>
  <p>
    Taylor Institute for Teaching and Learning supports building and sharing teaching expertise; integrating
    technologies to enhance learning; and conducting inquiry to improve student learning. Through the College of
    Discovery and Innovation, the Taylor Institute offers undergraduate students opportunities for inquiry-based
    learning, experiential learning and interdisciplinary research.
  </p>
  <p>
    To learn more about the Curriculum Links project, visit <a href="https://curriculumlinks.ucalgary.ca"
      target="_blank">https://curriculumlinks.ucalgary.ca</a>
  </p>

  <div class="divider"></div>

  <div class="footer">

    <div class="footer-links">
      <a (click)="openDisclaimer()">Curriculum Links User Agreement</a>
      <!--
        | <a (click)="openFeedback()">Feedback</a> 
      -->
    </div>

    <div class="footer-image">

      <!-- <div class="copyright">© 2019 University of Calgary</div> -->
      <img src="assets/images/uc-horz-rgb.png">
    </div>

  </div>




</div>


<div class=" modal-window" [ngClass]="{'show': shouldShowDisclaimer}">


  <div class="modal-window-content disclaimer">
    <i class="close icon" (click)="closeDisclaimer()"></i>
    <div [innerHTML]="appInfo.terms"></div>
  </div>

</div>